const parseMaskingPharmacyIds = () => {
  return String(process.env.REACT_APP_MASK_PATIENT_DETAILS_PHARMACY_IDS || "")
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);
};

const isPatientMaskingEnabled = () => {
  return String(process.env.REACT_APP_MASK_PATIENT_DETAILS || "").toLowerCase() === "true";
};

export const shouldMaskPatientDetails = (pharmacyId) => {
  if (!isPatientMaskingEnabled()) return false;

  const maskingPharmacyIds = parseMaskingPharmacyIds();
  if (maskingPharmacyIds.length === 0) return true;
  if (pharmacyId == null || pharmacyId === "") return false;

  return maskingPharmacyIds.includes(String(pharmacyId));
};

export const maskPatientNamePart = (value, options = {}) => {
  const text = String(value || "").trim();
  if (!text) return "";

  const upper = text.toUpperCase();
  if (upper.length <= 2) return `${upper}XX`;

  const trailingVisible = options.wrap ? 0 : Math.min(3, upper.length);
  const visiblePrefix =
    trailingVisible > 0 ? upper.slice(0, upper.length - trailingVisible) : upper;
  const visibleSuffix = trailingVisible > 0 ? upper.slice(-trailingVisible) : "";

  return `XXX${visiblePrefix}XX${visibleSuffix}`;
};

export const maskPatientPhoneLike = (value) => {
  const text = String(value || "").trim();
  if (!text) return "";

  const digits = text.replace(/\D/g, "");
  if (digits.length <= 5) return `${digits}XXXXX`;

  return `${digits.slice(0, 6)}XXXXX`;
};

export const maskPatientAddress = (value) => {
  const text = String(value || "").trim();
  if (!text) return "";

  const parts = text.split(",").map((part) => part.trim()).filter(Boolean);
  if (parts.length === 0) return text;

  const [first, ...rest] = parts;
  const maskedFirst = first
    .split(/\s+/)
    .map((segment, index) => {
      if (/^\d+$/.test(segment)) {
        return index === 0 ? segment : `${segment.slice(0, 1)}XX`;
      }
      if (segment.length <= 2) return `${segment.toUpperCase()}XX`;
      return `${segment.slice(0, 2).toUpperCase()}XXX`;
    })
    .join(" ");

  return [maskedFirst, ...rest].join(", ");
};

export const maskHeaderText = (value) => {
  const text = String(value || "").trim();
  if (!text) return "";

  return text
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => {
      const upper = part.toUpperCase();
      if (upper.length <= 2) return `${upper}XX`;
      if (upper.length <= 5) return `XXX${upper}XX`;
      return `XXX${upper.slice(0, upper.length - 2)}XX`;
    })
    .join(" ");
};
